/**
 * Ukupna cijena stavki gost-narudžbe. Paket nosi izbore u `prilog[]` (djeca sa parent_id).
 * Pravilo backenda: `price` izbora je doplata ZA JEDAN paket, a cijena paketa ne sadrži doplate:
 *   ukupno stavke = (cijena paketa + zbir (price × quantity) izabranih jela) × količina paketa
 * Primjer: paket 2650, doplata 200, količina 2 → (2650 + 200) × 2 = 5700.
 */
const amount = (price, quantity) =>
  (parseFloat(price) || 0) * (parseFloat(quantity) || 0);

export const transactionTotal = (transaction) => {
  if (!transaction) {
    return 0;
  }
  const choices = Array.isArray(transaction.prilog) ? transaction.prilog : [];
  const perPackage = choices.reduce(
    (sum, choice) => sum + amount(choice.price, choice.quantity),
    parseFloat(transaction.price) || 0
  );
  return perPackage * (parseFloat(transaction.quantity) || 0);
};

export const transactionsTotal = (transactions) =>
  (Array.isArray(transactions) ? transactions : []).reduce(
    (sum, transaction) => sum + transactionTotal(transaction),
    0
  );

export const orderTotal = (order) => transactionsTotal(order?.order_guest_transactions);
